
import { EnviarMensajeRequest } from './../../services/request/enviarMensajeRequest';
import { EnviarEscribiendoRequest } from './../../services/request/enviarEscribiendoRequest';
import { ChatService } from './../../services/chat.service';
import { Message } from './../../models/message';
import { Component, OnInit, Input, OnChanges, SimpleChanges, SimpleChange, EventEmitter, Output } from '@angular/core';
import { take } from 'rxjs/operators';
import { alissMensajes } from '../../utils/aliss-mensajes';

import { regExp } from '../../utils/regularExpresions';
import { LocalStorageService } from 'src/app/asistente-en-linea/services/local-storage.service';
import { Contexto } from 'src/app/asistente-en-linea/models/contexto';
import { VentanaUtils } from '../../../../utils/ventana.utils';
import { ConciergeService } from '../../../../services/concierge.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmModalComponent } from '../../../confirm-modal/confirm-modal.component';


@Component({
  selector: 'app-message-form',
  templateUrl: './message-form.component.html',
  styleUrls: ['./message-form.component.scss']
})
export class MessageFormComponent implements OnInit {

  @Input()
  public agentesDisponibles: boolean;

  @Input()
  public message: Message;

  @Input()
  public messages: Message[];

  @Input()
  public positionQueue: number;

  @Input()
  public agenteAssigned: string;

  @Input() participantID: string;
  participantIDChild = '';

  @Input() agentTyping: boolean;

  @Output() procesarRespuesta = new EventEmitter<any>();

  @Output() iniciarChat = new EventEmitter<any>();

  @Output() switchHandlerEmitter = new EventEmitter<Object>();

  @Output() changeContextDataEmitter = new EventEmitter<Object>();

  conversationSequenceNumber: number;
  envioHistoricoTimeout = false;

  @Input() public ctx: Contexto;

  @Input()
  public mensajesGuardados: Message[] = [];

  @Input()
  public cambioDeServicio: boolean;
  @Input()
  public fueraHorario: boolean;
  @Input()
  public habilitado: boolean;

  constructor(private rest: ChatService,
    private localstorage: LocalStorageService,
    public conciergeService: ConciergeService,
    public dialog: MatDialog,
    public window: VentanaUtils
  ) { }

  ngOnInit() { }

  getPlaceholder(): string {
    if (!this.agentesDisponibles && this.positionQueue !== 0) {
      return `Tu lugar para ser atendido es ${this.positionQueue}`;
    }
    if (this.agentesDisponibles && !this.fueraHorario) {
      return 'Escriba su mensaje';
    }
    return '';
  }

  switchAssistantHandler() {
    this.ctx.codAsistenteError = undefined;
    this.ctx.esReporteError = false;

    const participantID: string = this.localstorage.getParticipantID();
    if (participantID && participantID.length > 0) {
      if (this.localstorage.getHandlerType() === 'chat' && this.ctx.codAsistente && this.localstorage.getAsistenteID() === this.ctx.codAsistente.toString()) {
        const dialogRef = this.dialog.open(ConfirmModalComponent,
          { data: { message: alissMensajes.confirmacionCierre, btnOK: 'SI', btnNOK: 'NO' }, panelClass: 'custom-modalbox' });
        dialogRef.afterClosed().subscribe(result => {
          if (result && result === ConfirmModalComponent.OK) {
            // Se limplia el localstorage
            this.localstorage.cleanStorage();

            //this.renderComponent(this.utils.renderMenu);
            // Al cerrar la ventana se debe hacer resize del iframe (minimizar)
            this.window.setDefaultIframeSize();

            // Chequeo para mostrar le feedback al dar Ok en finalizar la comunicación sólo si hay una 
            // conversación con un asesor. Si el usuario se encuentra en cola y acepta finalizar la comunicación
            // no muestra el feedback.
            if (this.ctx.interactionInfo.agentName) {
              this.abrirEncuesta();
            }
          }
        });
      }
    } else {
      if (this.localstorage.getChatIniciado()) {
        this.abrirEncuesta();
      } else {
        this.volverInicio();
      }
    }
  }

  /**
   * Abre la encuesta siempre que exista un codigo asociado al ID de servicio
   * @param codAsistente ID del asistente
   */
  abrirEncuesta() {
    console.log("Ejecutando encuesta: %s", this.ctx.destinatarioChat!.codigoEncuesta);
    if (this.ctx.destinatarioChat.requiereEncuesta && this.ctx.destinatarioChat.codigoEncuesta != undefined && this.ctx.destinatarioChat.codigoEncuesta != '') {
      const encuestaFunction = 'ejecutarAbrirEncuesta';
      const ejecutarAbrirEncuesta = parent[encuestaFunction];
      ejecutarAbrirEncuesta(this.ctx.destinatarioChat.codigoEncuesta, [''], {});
    } else {
      console.log("No hay codigo de encuesta para ID servicio: %s", this.ctx.codAsistente);
    }
    this.volverInicio();
  }

  volverInicio() {
    this.ctx.idNodo = 'desdeChat';
    this.ctx.idMenu = this.ctx.historialMenus[0];
    this.ctx.codAsistente = this.ctx.codAsistenteOriginal;
    this.localstorage.setChatIniciado(false);
    this.window.close.emit();
    if (this.ctx.fromAnonymous) {
      // this.window.close.emit();
      if (window.opener) {
        window.opener.postMessage({ accion: 'cerrarPopup' }, '*');
      }
    } else {
      this.ctx.codAsistenteError = undefined;
      this.ctx.idMenu = this.ctx.historialMenus[0];
      this.ctx.historialMenus = [];
      this.ctx.codAsistente = this.ctx.codAsistenteOriginal;

      // almacena informacion de navegacion
      this.ctx.navigationHistory.codAsistente = this.ctx.codAsistente;
      this.ctx.navigationHistory.idServicio = this.ctx.idServicio;
      this.ctx.navigationHistory.idMenu = this.ctx.idMenu;
      this.ctx.navigationHistory.idFormAsociado = this.ctx.idFormAsociado;
      this.switchHandlerEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, idMenu: this.ctx.idMenu });
    }
  }

  emitChangeContextDataEmitter(event) {
    this.changeContextDataEmitter.emit(event);
  }

  public setParticipantIDChild(part) {
    this.participantIDChild = part;
  }

  public sendHistoricalMessage(): void {
    if ((this.participantIDChild !== '') && (this.mensajesGuardados.length > 0)) {
      this.participantID = this.participantIDChild;
      let historico = '';
      let actor = '';
      for (const m of this.mensajesGuardados) {
        let contenido = m.content;
        // Se utiliza para quitar saltos de linea agregados con el Enter al enviar
        contenido = contenido.replace(regExp.endLine, '');
        if (m.client) {
          actor = this.envioHistoricoTimeout ? 'Usuario: ' : '';
          historico = historico + actor + contenido + '\n';
        } else if (m.system) {
          actor = this.envioHistoricoTimeout ? '* ' : '';
          historico = historico + actor + contenido + actor + '\n';
        } else {
          actor = this.envioHistoricoTimeout ? 'Asesor: ' : '';
          historico = historico + actor + contenido + '\n';
        }
      }
      this.message = new Message(historico, 'assets/images/bps-avatar.png',
        '', new Date(), false, true, 0, 0);
      this.enviarMensaje();
      this.mensajesGuardados = [];
      this.envioHistoricoTimeout = false;
      // limpia el textArea
      this.message = new Message('', 'assets/images/user.png', '');
    }
  }

  public sendMessage(): void {
    // Se controla haber presionado Enter sin haber escrito mensaje
    let NEWLINE = '\n';
    let CARRIAGERETURN = '\n';

    if (this.message && this.message.content
      && this.message.content.trim().length > 0
      && this.message.content != NEWLINE
      && this.message.content != CARRIAGERETURN) {
      this.message.timestamp = new Date();
      this.message.client = true;
      this.messages.push(this.message);
      const mensajeAEnviar = this.message;
      // Si ya hay un agente asignado: envio los mensajes
      if (this.agenteAssigned && this.participantID) {
        this.message = mensajeAEnviar;
        this.enviarMensaje();
        // Si aún no tiene el agente asignado guardo los mensajes para enviar despues
      } else {
        if (this.localstorage.isTimeout()) {
          // Se agrega chequeo de messages undefined para el caso de timeout sin envio de histórico.
          // De todos modos manda el separador de asteriscos para saber que esta conversación viene de un tiemout
          this.mensajesGuardados = (!(this.localstorage.getMessages() === undefined)) ? this.localstorage.getMessages() : [];

          this.mensajesGuardados.push(new Message(alissMensajes.separadorHistorico, 'assets/images/bps-avatar.png',
            '', new Date(), false, true, 0, 0));
          this.envioHistoricoTimeout = true;
        }
        this.mensajesGuardados.push(mensajeAEnviar);
        if (!this.participantID) {
          this.iniciarChatPadre();
        }
      }
      // Limpia el textArea
      this.message = new Message('', 'assets/images/user.png', '');
    } else {
      // Caso en el que solamente se ha presionado boton enter sin ingresar texto
      // o se ingresan caracteres vacios
      this.message.content = "";
    }

  }

  enviarMensaje() {
    const req = new EnviarMensajeRequest();
    req.mensaje = this.message.content;
    req.idAsistente = this.ctx.idAsistente;
    req.participantID = this.participantID;
    req.agente = this.agenteAssigned;
    req.idNodo = this.ctx.idNodo;
    req.chat = this.ctx.destinatarioChat;
    //el participantID ya se encuentra en el contexto (lo hace el iniciarChat)
    //req.participantID = this.participantID;
    this.rest.enviarMensaje(req).pipe(take(1)).subscribe(result => {
      console.log("Respuesta de enviarMensaje():: %s", JSON.stringify(result));
      if (!(result === undefined)) {
        // Lo pasamos el componente padre para procesar la respuesta
        this.procesarRespuestaPadre(result);
      }
    }, (err) => {
      console.log("Error en enviarMensaje():: mensaje de error: %s", err);
    }
    );
  }

  iniciarChatPadre() {
    this.iniciarChat.next();
  }

  procesarRespuestaPadre(result: any) {
    this.procesarRespuesta.next(result);
  }

  escribiendo(indicador) {
    if ((this.participantID !== '') && (this.participantID !== undefined)) {
      const req = new EnviarEscribiendoRequest();
      req.indicador = indicador;
      req.participantID = this.participantID;
      this.rest.enviarEscribiendo(req).pipe(take(1)).subscribe(res => {
        //No se hace nada con la respuesta
      });
    }
  }



}
